module.exports = __webpack_public_path__ + "media/components/nearby-points/static/photo-5-2fba06debde7da7293ff71d2da68adc4.jpg";